<template>
  <div class="content">
    <div class="row-data tdi-toolbar-card">
      <div class="tdi-card-head">
        <div>
          <p class="tdi-card-title">Quản lý thời khóa biểu</p>
          <p class="tdi-card-subtitle">Tra cứu và quản lý lịch học của học sinh</p>
        </div>
        <div class="button-click row-data" style="margin-bottom: 0;">
          <el-dropdown
              v-if="checkPermission(['studentQuality_schedule_update'])"
              @command="handleCommandAdd"
          >
            <el-button type="success" style="border-radius: 18px; margin-right: 10px;">
              <i class="el-icon-plus"/> Thêm mới
            </el-button>
            <el-dropdown-menu class="el-dropdown-menu-container">
              <el-dropdown-item command="createSchedule">Nhập thời khóa biểu</el-dropdown-item>
              <el-dropdown-item command="createScheduleFile">Thêm dạng File,Ảnh</el-dropdown-item>
              <el-dropdown-item command="createScheduleExcel">Thời khóa biểu từ Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="handleCommandAction">
            <el-button type="primary" style="border-radius: 18px;">
              Tác vụ <i class="el-icon-caret-bottom"/>
            </el-button>
            <el-dropdown-menu class="el-dropdown-menu-container">
              <span v-if="checkPermission(['studentQuality_schedule_update'])">
                <el-dropdown-item command="activeAccount">Duyệt thời khóa biểu</el-dropdown-item>
                <el-dropdown-item command="unactiveAccount">Hủy duyệt TKB</el-dropdown-item>
                <el-dropdown-item command="deleteContentSchedule">Xóa nội dung TKB</el-dropdown-item>
              </span>
              <el-dropdown-item command="exportExcel">Xuất File Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <el-form label-position="top" class="tdi-form-grid" @submit.native.prevent>
        <el-form-item label="Chế độ xem" class="tdi-form-item">
          <el-radio-group v-model="radio" @change="handleRadio" size="medium" class="custom-radio-pill">
            <el-radio-button label="1">Xem TKB</el-radio-button>
            <el-radio-button label="2">Chi tiết</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <template v-if="radio === '1'">
          <el-form-item label="Chọn tuần" class="tdi-form-item">
            <el-date-picker
                v-model="timeSchedule"
                type="week"
                value-format="yyyy-MM-dd"
                format="Tuần WW(từ dd-MM-yyyy)"
                placeholder="Chọn tuần"
                :clearable="false"
                style="width: 240px"
                @change="searchByProperties()"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Chọn khối" class="tdi-form-item" v-if="getAppTypeUserLogin === 'plus'">
            <el-select
                v-model="dataSearch.idGrade"
                @change="changeGrade()"
                placeholder="Chọn khối"
                :clearable="true"
                style="width: 160px"
            >
              <el-option
                  v-for="item in gradeOfSchoolList"
                  :key="item.id"
                  :label="item.gradeName"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Chọn lớp" class="tdi-form-item">
            <el-select
                v-model="dataSearch.idClass"
                @change="searchByProperties()"
                placeholder="Chọn lớp"
                :clearable="true"
                style="width: 160px"
            >
              <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :label="item.className"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-if="radio === '2'">
          <el-form-item label="Chọn tuần" class="tdi-form-item">
            <el-date-picker
                v-model="timeSchedule"
                type="week"
                value-format="yyyy-MM-dd"
                format="Tuần WW(từ dd-MM-yyyy)"
                placeholder="Chọn tuần"
                :clearable="false"
                style="width: 240px"
                @change="getAllScheduleDetail"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Chọn khối" class="tdi-form-item" v-if="getAppTypeUserLogin === 'plus'">
            <el-select
                v-model="dataSearch.idGrade"
                @change="changeGradeDetail"
                placeholder="Chọn khối"
                :clearable="true"
                style="width: 160px"
            >
              <el-option
                  v-for="item in gradeOfSchoolList"
                  :key="item.id"
                  :label="item.gradeName"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Chọn lớp" class="tdi-form-item">
            <el-select
                v-model="dataSearch.idClass"
                @change="getAllScheduleDetail"
                placeholder="Chọn lớp"
                clearable
                style="width: 160px"
            >
              <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :label="item.className"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <!-- Màn hình xem -->
    <div v-show="radio === '1'" style="display: flex; justify-content: flex-end; margin-bottom: 12px; padding-right: 16px;">
      <el-button type="primary" plain round size="small" @click="toggleAllCollapse()">
        <i :class="isAllCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="margin-right: 5px;"></i>
        {{ isAllCollapsed ? 'Mở rộng tất cả' : 'Thu gọn tất cả' }}
      </el-button>
    </div>
    <div
        v-show="radio === '1'"
        class="table-content row-data tdi-table-card"
        v-for="(item, index) in tableDataFilter"
        :key="index"
    >
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; cursor: pointer" @click="toggleCollapse(index)">
        <h3 style="color: #2563eb; margin: 0; font-weight: bold; text-transform: uppercase;">
          THỜI KHÓA BIỂU: {{ item.className }}
        </h3>
        <el-button type="text" :icon="collapsedMap[index] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="font-size: 18px; color: #2563eb; padding: 0;"></el-button>
      </div>
      <el-collapse-transition>
      <el-table
          v-show="!collapsedMap[index]"
          class="modern-schedule-table"
          :empty-text="textTable"
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          :data="item.scheduleDayResponeList"
          highlight-current-row
          :max-height="$tableMaxHeight"
      >
        <el-table-column prop="sessionDay" label="Buổi" align="center" width="100" label-class-name="pill-header pill-session">
          <template v-slot:default="scope">
            <div style="font-weight: 700; color: #475569; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px;">
              {{ scope.row.sessionDay }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="monday" label="Thứ 2" align="center" label-class-name="pill-header pill-mon">
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-mon', { 'has-content': scope.row.monday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.monday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Thứ 2" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 2)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tuesday" label="Thứ 3" align="center" label-class-name="pill-header pill-tue">
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-tue', { 'has-content': scope.row.tuesday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.tuesday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Thứ 3" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 3)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="wednesday" label="Thứ 4" align="center" label-class-name="pill-header pill-wed">
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-wed', { 'has-content': scope.row.wednesday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.wednesday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Thứ 4" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 4)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="thursday" label="Thứ 5" align="center" label-class-name="pill-header pill-thu">
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-thu', { 'has-content': scope.row.thursday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.thursday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Thứ 5" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 5)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="friday" label="Thứ 6" align="center" label-class-name="pill-header pill-fri">
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-fri', { 'has-content': scope.row.friday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.friday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Thứ 6" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 6)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            v-if="item.morningSaturday || item.afternoonSaturday || item.eveningSaturday"
            prop="saturday"
            label="Thứ 7"
            align="center"
            label-class-name="pill-header pill-sat"
        >
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-sat', { 'has-content': scope.row.saturday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.saturday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Thứ 7" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 7)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            v-if="item.sunday"
            prop="sunday"
            label="CN"
            align="center"
            label-class-name="pill-header pill-sun"
        >
          <template v-slot:default="scope">
            <div :class="['schedule-card', 'card-sun', { 'has-content': scope.row.sunday && scope.$index !== 0 }, scope.$index === 0 ? 'is-title' : '']">
              <span class="schedule-text">{{ scope.row.sunday || (scope.$index !== 0 ? 'Trống' : '') }}</span>
              <el-tooltip effect="dark" content="Chỉnh sửa TKB Chủ nhật" placement="top">
                <el-button
                    v-if="scope.$index !== 0"
                    size="mini"
                    type="text"
                    class="edit-btn-absolute"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row, 8)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </el-collapse-transition>
    </div>

    <!-- Màn hình chi tiết -->
    <div v-if="radio === '2'" class="table-content row-data tdi-table-card">
      <el-table
          class="modern-detail-table"
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          @selection-change="handleSelectionChange"
          :data="tabListScheduleDetail"
          highlight-current-row
          :max-height="$tableMaxHeight"
          stripe
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column
            type="index"
            label="STT"
            align="center"
            width="70px"
        ></el-table-column>
        <el-table-column
            prop="gradeName"
            label="Tên khối học"
            min-width="150px"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="className"
            label="Tên lớp"
            align="center"
        ></el-table-column>
        <el-table-column prop="approve" align="center" label="Duyệt" width="100px">
          <template v-slot:default="scope">
            <el-checkbox
                v-if="
                scope.row.listCheckContentDay !== null ||
                scope.row.fileList != null
              "
                v-model="scope.row.approve"
                @change="handleCheckBoxApprove(scope.$index, scope.row)"
            ></el-checkbox>
            <el-checkbox v-else disabled></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
            prop="listCheckContentDay"
            label="Các ngày có nội dung"
            align="center"
        >
          <template v-slot:default="scope">
            {{ scope.row.listCheckContentDay }}
            <el-tooltip effect="dark" content="Chỉnh sửa nội dung" placement="top">
              <el-button
                  size="mini"
                  type="text"
                  class="edit-btn-absolute"
                  icon="el-icon-edit"
                  @click="handleEditDetailClass(scope.$index, scope.row, 2)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
            prop="listFileOrPicture"
            label="TKB dạng File,Ảnh"
            align="center"
        >
          <template v-slot:default="scope" v-bind="scope.row.fileList">
            <el-upload
                class="upload-demo"
                ref="upload"
                action
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :before-upload="handleBeforeUpload"
                multiple
                :auto-upload="false"
                :on-change="handleChangeFile"
                :limit="5"
                :on-exceed="handleExceed"
                :on-preview="handleFileRequest"
                :file-list="scope.row.fileList == null ? [] : scope.row.fileList"
            >
              <el-tooltip effect="dark" content="Nhập file" placement="top">
                <el-button
                    v-if="checkPermission(['studentQuality_schedule_update'])"
                    @click="getIndexRow(scope.$index)"
                    size="mini"
                    type="primary"
                    icon="el-icon-upload2"
                    circle
                ></el-button>
              </el-tooltip>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column label="Tác vụ" align="center" width="120">
          <template v-slot:default="scope">
            <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
              <el-tooltip
                  v-if="checkPermission(['studentQuality_schedule_update'])"
                  effect="dark"
                  content="Lưu File"
                  placement="top"
              >
                <el-button
                    size="mini"
                    type="success"
                    icon="el-icon-document-checked"
                    circle
                    :disabled="checkSave"
                    @click="handleChangeFileSchedule()"
                ></el-button>
              </el-tooltip>

              <el-tooltip
                  effect="dark"
                  content="Xem chi tiết"
                  placement="top"
              >
                <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-view"
                    circle
                    @click="handleViewDetail(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <UpdateSchedule
        :dialogVisible="showUpdateDialog"
        @dialog-close="dialogCloseUpdateMethod()"
        ref="UpdateSchedule"
    />
    <CreateSchedule
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
        ref="CreateSchedule"
    />
    <CreateScheduleExcel
        :dialogVisibleEx="showCreateExcelDialog"
        @dialog-close="dialogCloseCreateExcelMethod()"
        ref="CreateScheduleExcel"
    />
    <CreateClassScheduleFile
        :dialogVisibleFile="showCreateFileDialog"
        @dialog-close="dialogCloseCreateFileMethod()"
        ref="CreateClassScheduleFile"
    />
    <SchdeduleDetail
        :dialogVisible="showViewDetailDialog"
        @dialog-close="dialogCloseViewDetailMethod()"
        ref="ScheduleDetail"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import ScheduleService from "../../services/ScheduleService";
import UpdateSchedule from "./UpdateSchedule.vue";
import CreateSchedule from "./CreateSchedule.vue";
import CreateScheduleExcel from "./CreateScheduleExcel.vue";
import CreateClassScheduleFile from "./CreateClassScheduleFile.vue";
import SchdeduleDetail from "./ScheduleDetail.vue";
import moment from "moment";
import http from "../../http-download";
import {mapState} from "vuex";

export default {
  components: {
    UpdateSchedule,
    CreateSchedule,
    SchdeduleDetail,
    CreateScheduleExcel,
    CreateClassScheduleFile,
  },
  data() {
    return {
      loadingData: true,
      textTable: "",
      layout: "sizes, prev, pager, next",
      total: 10,
      pageSize: 10,
      currentPageNumber: 1,
      timeSchedule: "",
      dateTitle: "",
      scheduleTitle: "",
      dialogVisibleTitle: false,
      radio: "1",
      isAllCollapsed: false,
      collapsedMap: {},
      multipleSelection: [],
      multipartFileList: [],
      indexRow: 0,
      loadingButton: false,
      checkSave: false,
      // offset : this.currentPageNumber*this.pageSize-this.pageSize,
      pageList: [10, 20, 30, 40, 50, 10000],
      tableDataFilter: [],
      listFileAndPicture: [],
      tabListScheduleDetail: [],

      showUpdateDialog: false,
      showCreateDialog: false,
      showCreateExcelDialog: false,
      showCreateFileDialog: false,
      showViewDetailDialog: false,
      dataSearch: {
        idGrade: "",
        idClass: "",
      },
      //css excel
      styleCols1: [],
      styleCols2: [],
    };
  },
  created() {
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
      this.$store.dispatch('classStore/fetchDataClassListCommon');
    }
    if (this.getAppTypeUserLogin === "teacher") {
      this.$store.dispatch('classStore/fetchDataClassInTeacher')
    }
  },

  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade);
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      } else return this.classListCommon
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  watch: {
    // gradeOfSchoolList: {
    //   immediate: true, // Kích hoạt ngay lập tức khi component được tạo
    //   handler(newVal) {
    //     if (newVal.length > 0 && this.getAppTypeUserLogin === "plus") {
    //       this.getIdGrade();
    //     }
    //   },
    // },
    // classList: {
    //   handler(newVal) {
    //     if (newVal.length > 0 && this.getAppTypeUserLogin === "teacher") {
    //       this.getIdClassInTeacher();
    //     }
    //   },
    // }
  },
  methods: {
    toggleAllCollapse() {
      this.isAllCollapsed = !this.isAllCollapsed;
      this.tableDataFilter.forEach((item, index) => {
        this.$set(this.collapsedMap, index, this.isAllCollapsed);
      });
    },
    toggleCollapse(index) {
      this.$set(this.collapsedMap, index, !this.collapsedMap[index]);
      this.isAllCollapsed = this.tableDataFilter.every((item, idx) => this.collapsedMap[idx]);
    },
    checkPermission,
    handleRemove(file) {
      ScheduleService.deleteScheduleFile(file.idUrlScheduleFile)
          .then((res) => {
            console.log(res.data.data);
            this.$message({
              message: "Xóa file thời khóa biểu thành công",
              type: "success",
            });
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Xóa file thời khóa biểu thất bại",
              type: "error",
            });
          });
    },
    handleBeforeUpload() {
      this.$refs.upload.clearFiles();
    },
    handleFileRequest(file) {
      let extensionFile = file.name.split(".").pop();
      let label = file.name;
      let idUrlScheduleFile = file.idUrlScheduleFile;
      this.downloadItem(label, extensionFile, idUrlScheduleFile);
    },
    downloadItem(label, extensionFile, idUrlScheduleFile) {
      http
          .get(`/schedules/download2/${idUrlScheduleFile}`)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", label);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Thất bại",
              type: "error",
            });
          });
    },
    handleChangeFile(file, fileList) {
      this.multipartFileList = fileList;
    },
    handleChangeFileSchedule() {
      // this.loadingButton = true;
      this.checkSave = true;
      let formData = new FormData();

      let idClass = this.tabListScheduleDetail[this.indexRow].idClass;
      let approved = this.tabListScheduleDetail[this.indexRow].approve;

      if (this.multipartFileList.length > 0) {
        this.multipartFileList.forEach((element) => {
          formData.append("multipartFileList", element.raw);
        });
      }
      formData.append("fromFileTsime", this.timeSchedule);
      formData.append("Approved", approved);
      formData.append("idClass", idClass);
      ScheduleService.createFileAndPicture(formData)
          .then((res) => {
            if (res.data) {
              this.$message({
                message: "Tải lên file thời khóa biểu thành công",
                type: "success",
              });
              this.getAllScheduleDetail();
              this.multipartFileList = [];
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Tải lên file thời khóa biểu thất bại",
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.checkSave = false;
            }, 500);
          });
    },
    getIndexRow(index) {
      this.indexRow = index;
      this.$refs.upload.clearFiles();
    },

    tableHeaderColor() {
      return "background-color: #2563eb;color: #fff;font-weight: 600;";
    },

    handleEdit(index, row, timeDay) {
      this.$refs.UpdateSchedule.getScheduleInClassWeek(
          this.timeSchedule ? moment(this.timeSchedule).startOf("isoWeek").format("YYYY-MM-DD") : "",
          row.idClass,
          timeDay,
          row.className
      );

      this.$refs.UpdateSchedule.getStatusWeekend(
          row.morningSaturday,
          row.afternoonSaturday,
          row.eveningSaturday,
          row.sunday
      );
      this.showUpdateDialog = true;
    },
    handleEditDetailClass(index, row, timeDay) {
      this.$refs.UpdateSchedule.getScheduleInClassWeek(
          this.timeSchedule,
          row.idClass,
          timeDay
      );
      this.showUpdateDialog = true;
    },
    handleCheckBoxApprove(index, row) {
      console.log(row);
      console.log("hi");

      ScheduleService.updateApprove(row)
          .then((res) => {
            console.log(res);
            if (row.approve) {
              this.$message({
                message: "Duyệt thời khóa biểu thành công",
                type: "success",
              });
            } else {
              this.$message({
                message: "Hủy duyệt thời khóa biểu thành công",
                type: "success",
              });
            }
          })
          .catch((e) => {
            console.log(e);
            this.$message({
              message: "Duyệt thời khóa biểu thất bại",
              type: "error",
            });
          });
    },
    handleRadio() {
      const a = this.radio;
      this.dataSearch.idGrade = "";
      this.dataSearch.idClass = "";

      if (a === '2') {
        this.getAllScheduleDetail();
      } else if (a === '1') {
        this.searchByProperties();
      }
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
      this.searchByProperties();
      this.getAllScheduleDetail(this.timeSchedule);
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
      this.searchByProperties()
    },
    dialogCloseCreateExcelMethod() {
      this.showCreateExcelDialog = false;
      this.searchByProperties()
    },
    dialogCloseCreateFileMethod() {
      this.showCreateFileDialog = false;
      this.searchByProperties();
      this.getAllScheduleDetail(this.timeSchedule);
    },
    dialogCloseViewDetailMethod() {
      this.showViewDetailDialog = false;
      this.getAllScheduleDetail(this.timeSchedule);
      // this.searchByProperties(
      //   this.timeSchedule,
      //   this.dataSearch.idGrade,
      //   this.dataSearch.idClass
      // );
    },
    searchByProperties() {
      const time_schedule = this.timeSchedule ? moment(this.timeSchedule).startOf("isoWeek").format("YYYY-MM-DD") : "";
      const id_grade = this.dataSearch.idGrade ? this.dataSearch.idGrade : "";
      const id_class = this.dataSearch.idClass ? this.dataSearch.idClass : "";

      this.loadingData = true;
      ScheduleService.search(time_schedule, id_grade, id_class)
          .then((response) => {
            // if (this.getAppTypeUserLogin === "teacher") {
            //   this.tableDataFilter = id_class !== "" ? response.data.data : [];
            // } else {
            this.tableDataFilter = response.data.data;
            // }

            this.formatterData();
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            if (this.tableDataFilter.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },

    getCurrentDate() {
      (this.timeSchedule = moment(String(new Date()))
          .startOf("isoweek")
          .format("YYYY-MM-DD"));
      moment(String(new Date()))
          .startOf("isoweek")
          .add(1, "days")
          .format("YYYY-MM-DD");
    },

    handleCommandAdd(command) {
      if (command === "createSchedule") {
        this.showCreateDialog = true;
        this.$refs.CreateSchedule.getAllClass();
      }
      if (command === "createScheduleExcel") {
        this.showCreateExcelDialog = true;
        this.$refs.CreateScheduleExcel.getAllClass();
      }
      if (command === "createScheduleFile") {
        this.showCreateFileDialog = true;
        this.$refs.CreateClassScheduleFile.getAllClass();
      }
    },
    handleCommandAction(command) {
      if (command === "activeAccount") {
        this.updateMultiActivated(true);
      } else if (command === "unactiveAccount") {
        this.updateMultiActivated(false);
      } else if (command === "deleteContentSchedule") {
        this.deleteContentSchedule();
      } else if (command === "exportExcel") {
        this.exportExcelSchedule();
      }
    },
    handleExceed() {
      this.$message.warning("Bạn chỉ được chọn 5 files");
    },
    beforeRemove(file) {
      return this.$confirm(`Bạn có muốn xóa file ${file.name} ?`);
    },
    //Chi tiết
    getAllScheduleDetail() {
      const time_schedule = this.timeSchedule ? moment(this.timeSchedule).startOf("isoWeek").format("YYYY-MM-DD") : "";
      const id_grade = this.dataSearch.idGrade ? this.dataSearch.idGrade : "";
      const id_class = this.dataSearch.idClass ? this.dataSearch.idClass : "";

      this.loadingData = true;
      ScheduleService.getAllScheduleDetail(
          time_schedule,
          id_grade,
          id_class
      )
          .then((res) => {
            // if (this.getAppTypeUserLogin === "teacher") {
            //   this.tabListScheduleDetail =
            //       this.dataSearch.idClass !== "" ? res.data.data : [];
            // } else {
              this.tabListScheduleDetail = res.data.data;
            // }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            if (this.tabListScheduleDetail.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // changeTitleMethod(item) {
    //   this.dateTitle = this.timeSchedule;
    //   this.scheduleTitle = item.scheduleTitle;
    //   this.idClassTitle = item.idClass;
    //   this.dialogVisibleTitle = true;
    // },
    // submitTitle() {
    //   let dataForTitle = {
    //     idClass: "",
    //     scheduleDate: "",
    //     scheduleTitle: "",
    //   };
    //   dataForTitle.idClass = this.idClassTitle;
    //   dataForTitle.scheduleDate = this.dateTitle;
    //   dataForTitle.scheduleTitle = this.scheduleTitle;
    //
    //   ScheduleService.updateTitleClass(dataForTitle)
    //       .then((response) => {
    //         console.log('check title', response.data.data);
    //         this.$message({
    //           message: "Cập nhật chủ đề thành công",
    //           type: "success",
    //         });
    //       })
    //       .then(() => {
    //         this.fetchDataMany();
    //         this.dialogVisibleTitle = false;
    //       })
    //       .catch((err) => {
    //         this.$message({
    //           message: "Cập nhật chủ đề thất bại",
    //           type: "error",
    //         });
    //         console.log(err);
    //       });
    // },

    handleClose() {
      this.dialogVisibleTitle = false;
    },

    updateMultiActivated(statusApprove) {
      let list = [];
      this.multipleSelection.forEach((x) => list.push(x.id));
      if (list.length === 0) {
        this.$message({
          message: "Không có nhân viên nào được chọn",
          type: "error",
        });

      } else {
        let e = this.multipleSelection.filter((element) => {
          return element.listCheckContentDay != null;
        });
        e.forEach((element) => {
          element.approve = statusApprove;
          console.log(element);
        });
        console.log("e");
        console.log(e);
        console.log("e");
        ScheduleService.updateMultiApprove(e)
            .then((res) => {
              console.log(res.data.data);
              if (statusApprove === true) {
                this.$message({
                  message: "Duyệt thời khóa biểu thành công",
                  type: "success",
                });
              } else if (statusApprove === false) {
                this.$message({
                  message: "Hủy duyệt thời khóa biểu thành công",
                  type: "success",
                });
              }
              this.getAllScheduleDetail(this.timeSchedule);
            })
            .catch((err) => {
              console.log(err);
              if (statusApprove === true) {
                this.$message({
                  message: "Duyệt thời khóa biểu thất bại",
                  type: "error",
                });
              } else if (statusApprove === false) {
                this.$message({
                  message: "Hủy duyệt thời khóa biểu thất bại",
                  type: "error",
                });
              }
            });
      }
    },
    handleViewDetail(index, row) {
      this.$refs.ScheduleDetail.getTabScheduleViewDetail(row.idClass);
      this.$refs.ScheduleDetail.getClassName(row.className);
      this.showViewDetailDialog = true;
    },

    exportExcelSchedule() {
      let id = this.dataSearch.idClass;
      let date = this.timeSchedule;
      if (id === "" || id === undefined) {
        this.$message({
          message: "Chưa chọn lớp",
          type: "error",
        });
        return;
      }
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        this.getStyleExcelTKB();
        let myDate = moment().format("DD-MM-YYYY hh:mm:ss");
        ScheduleService.getExportExcelSchedule(id, date)
            .then((resp) => {
              import("@/services/ExportExcel")
                  .then((excel) => {
                    let dataList = resp.data.data;
                    let fileName = `QUAN_LY_TKB_HOC_SINH_${myDate}`;
                    const merges = ["A1:H1"];
                    const tHeader = [
                      "Thời gian",
                      "Thứ hai/Monday",
                      "Thứ ba/Tuesday",
                      "Thứ tư/Wednesday",
                      "Thứ năm/Thursday",
                      "Thứ sáu/Friday",
                      "Thứ bảy/Sat",
                      "Chủ nhật/Sun",
                    ];
                    const filterVal = [
                      "pro1",
                      "pro2",
                      "pro3",
                      "pro4",
                      "pro5",
                      "pro6",
                      "pro7",
                      "pro8",
                    ];
                    let columnList = [
                      {col: 20},
                      {col: 20},
                      {col: 20},
                      {col: 20},
                      {col: 20},
                      {col: 20},
                      {col: 20},
                      {col: 20},
                    ];
                    excel.export_json_to_excel({
                      header: tHeader,
                      merges,
                      data: dataList,
                      title: filterVal,
                      filename: fileName,
                      checkCustom: "tkb",
                      columnsWidth: columnList,
                      styleCols1: this.styleCols1,
                      styleCols2: this.styleCols2,
                    });
                  })
                  .finally(() => {
                    this.styleCols1 = [];
                    this.styleCols2 = [];
                  });
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Thất bại",
                type: "error",
              });
            });
      });
    },
    //Style css Excel TKB
    getStyleExcelTKB() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();

      let style1 = {
        name: "A6:H6",
        style: {
          fill: {fgColor: {rgb: "ffff00"}},
          font,
          alignment,
          border,
        },
      };

      let styleCol01 = {
        name: ["A1"],
        style: {
          font: {color: {rgb: "ff0000"}, bold: true, sz: "18"},
          alignment: {horizontal: "center", vertical: "center"},
        },
      };
      let styleCol02 = {
        name: ["A2", "A3", "A4", "A5"],
        style: {
          font: {bold: true, sz: "11"},
        },
      };
      let styleCol03 = {
        name: ["A6"],
        style: {
          fill: {fgColor: {rgb: "ffff00"}},
          font: {color: {rgb: "ff0000"}, bold: true, sz: "11"},
          alignment,
          border,
        },
      };
      this.styleCols2.push(style1);

      this.styleCols1.push(styleCol01);
      this.styleCols1.push(styleCol02);
      //css cuối
      this.styleCols1.push(styleCol03);
    },
    deleteContentSchedule() {
      let e = this.multipleSelection.filter((element) => {
        return element.listCheckContentDay != null;
      });
      ScheduleService.deleteContentSchedule(e)
          .then((res) => {
            console.log(res.data.data);
            this.$message({
              message: "Xóa nội dung thời khóa biểu thành công",
              type: "success",
            });
            this.getAllScheduleDetail(this.timeSchedule);
          })
          .catch((e) => {
            console.log(e);
            this.$message({
              message: "Xóa nội dung thời khóa biểu thất bại",
              type: "error",
            });
          });
    },
    /**
     * đối khối cho tab detail
     */
    changeGrade() {
      // this.classInGradeMethod();
      this.searchByProperties();
    },
    async changeGradeDetail() {
      this.dataSearch.idClass = "";
      this.getAllScheduleDetail();
    },

    getIdGrade() {
      this.searchByProperties();
    },

    getIdClassInTeacher() {
      this.searchByProperties();
    },
    // classInGradeMethod() {
    //   this.dataSearch.idClass =
    //       this.classList.length > 0 ? this.classList[0].id : "";
    // },

    async fetchDataMany() {
      this.getCurrentDate();
      this.searchByProperties()
    },

    formatterData() {
      const data = this.tableDataFilter;
      const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

      data.forEach((dataItem) => {
        // Tạo đối tượng mới từ listScheduleTitle
        const newSchedule = {
          idClass: dataItem.idClass,
          className: dataItem.className,
          sessionDay: "",
        };

        // Gán các phần tử trong listScheduleTitle vào các ngày tương ứng
        days.forEach((day, index) => {
          newSchedule[day] = dataItem.listScheduleTitle[index] || null;
        });

        // Thêm đối tượng mới vào scheduleDayResponeList
        dataItem.scheduleDayResponeList.unshift(newSchedule);
      });
    }
  },

  beforeMount() {
    this.fetchDataMany();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

.tdi-toolbar-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin-bottom: 24px;
}
.tdi-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
}
.tdi-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}
.tdi-card-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 4px 0 0 0;
}
.tdi-form-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
}
.tdi-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}
/deep/ .tdi-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 13px;
  color: #475569;
  font-weight: 600;
  line-height: 1.5;
}
.tdi-table-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin-bottom: 24px;
}

.content {
  .row-data {
    margin-bottom: 20px;
  }

  .button-over {
    border-radius: 0;
    margin-left: 3px;
  }

  .button-left {
    width: 145px;
  }

  .button-click-left {
    display: inline-block;
  }

  .button-click {
    float: right;
  }

  .table-content {
    .el-table {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .paging-click {
    .el-pagination {
      text-align: right;
      margin: 30px 0;
    }
  }

  /deep/ .el-table th.gutter {
    background-color: #78a5e7;
  }

  // /deep/.el-table--scrollable-y .el-table__body-wrapper {
  //   overflow-y: auto;
  //   // margin-top: -1px;
  // }
  /deep/ .el-table .cell {
    // box-sizing: border-box;
    overflow-y: auto;
    white-space: pre-line;
    word-break: break-word;
    // line-height: 23px;
    padding-right: 10px;
    max-height: 150px;
    text-align: left;
    // text-overflow: ellipsis;
  }

  /deep/ .el-range-editor.el-input__inner {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    width: 260px;
  }

  /deep/ .el-input-group > .el-input__inner {
    vertical-align: middle;
    display: table-cell;
    margin-left: 5px;
  }

  /deep/ .element.style {
    width: 257px !important;
  }
}

/deep/ .el-table th > .cell {
  text-align: center !important;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: rgb(95, 180, 74);
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

li.el-select-dropdown__item.hover {
  background: rgb(111, 142, 189);
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 6px 0;
  max-height: 10px;
}

/* Old edit-btn replaced by modern UI */

.el-table .line-break .cell {
  white-space: pre;
}

.day_content {
  text-align: center;
  color: #0067ff;
}

/* MODERN SCHEDULE UI */
.modern-schedule-table {
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  background: #fff;
}
.modern-schedule-table /deep/ th.el-table__cell {
  background-color: transparent !important;
  border-bottom: none !important;
  padding: 16px 6px;
}

.modern-schedule-table /deep/ th.pill-header .cell {
  color: #ffffff !important;
  border-radius: 12px;
  padding: 10px 4px;
  font-weight: 800;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  word-break: break-word;
}
.modern-schedule-table /deep/ th.pill-header:hover .cell {
  transform: translateY(-3px) scale(1.02);
}

.modern-schedule-table /deep/ th.pill-session .cell {
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
  box-shadow: 0 4px 10px rgba(71, 85, 105, 0.3);
}
.modern-schedule-table /deep/ th.pill-mon .cell {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  box-shadow: 0 4px 10px rgba(245, 158, 11, 0.3);
}
.modern-schedule-table /deep/ th.pill-tue .cell {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
}
.modern-schedule-table /deep/ th.pill-wed .cell {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}
.modern-schedule-table /deep/ th.pill-thu .cell {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  box-shadow: 0 4px 10px rgba(139, 92, 246, 0.3);
}
.modern-schedule-table /deep/ th.pill-fri .cell {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  box-shadow: 0 4px 10px rgba(236, 72, 153, 0.3);
}
.modern-schedule-table /deep/ th.pill-sat .cell {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  box-shadow: 0 4px 10px rgba(20, 184, 166, 0.3);
}
.modern-schedule-table /deep/ th.pill-sun .cell {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3);
}
.modern-schedule-table /deep/ td.el-table__cell {
  border-bottom: 1px solid #f1f5f9;
  padding: 12px 8px;
}
.modern-schedule-table /deep/ .el-table__row:hover > td.el-table__cell {
  background-color: transparent !important;
}
.modern-schedule-table::before {
  display: none;
}

.schedule-card {
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  padding: 12px 10px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: #94a3b8;
  font-size: 13px;
  cursor: pointer;
}
.schedule-card.has-content {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid transparent;
  color: #1e40af;
  font-weight: 600;
  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.1), 0 2px 4px -1px rgba(59, 130, 246, 0.06);
}
.schedule-card.is-title {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid transparent;
  color: #991b1b;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.1);
  min-height: 40px;
  cursor: default;
}
.schedule-card:hover:not(.is-title) {
  transform: translateY(-3px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.schedule-card.has-content:hover:not(.is-title) {
  box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.2), 0 4px 6px -2px rgba(59, 130, 246, 0.1);
  border-color: #93c5fd;
}
.schedule-text {
  white-space: pre-line;
  word-break: break-word;
  line-height: 1.5;
  text-align: center;
}
.edit-btn-absolute {
  position: absolute !important;
  bottom: 8px !important;
  right: 8px !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  background: #ffffff !important;
  color: #2563eb !important;
  font-size: 16px !important;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border: none !important;
}
.schedule-card:hover .edit-btn-absolute {
  opacity: 1;
  transform: scale(1);
}
.edit-btn-absolute:hover {
  background: #2563eb !important;
  color: #ffffff !important;
  transform: scale(1.1) !important;
}

.modern-detail-table {
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e8f0;
}
.modern-detail-table /deep/ th.el-table__cell {
  background: linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%) !important;
  color: #1e293b !important;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  border-bottom: 2px solid #cbd5e1 !important;
  border-right: 1px solid #cbd5e1 !important;
  padding: 14px 8px;
}
.modern-detail-table /deep/ th.el-table__cell:last-child {
  border-right: none !important;
}
.modern-detail-table /deep/ td.el-table__cell {
  border-bottom: 1px solid #e2e8f0;
  border-right: 1px dashed #cbd5e1;
  padding: 14px 8px;
  transition: background-color 0.2s ease;
}
.modern-detail-table /deep/ td.el-table__cell:last-child {
  border-right: none;
}
.modern-detail-table /deep/ .el-table__row--striped td.el-table__cell {
  background-color: #f8fafc !important;
}
.modern-detail-table /deep/ .el-table__row:hover > td.el-table__cell {
  background-color: #eff6ff !important;
}


/* Card Colors Matching Headers */

/* Monday - Amber */
.schedule-card.card-mon.has-content {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-color: #fde68a;
  color: #b45309;
}
.schedule-card.card-mon.has-content:hover:not(.is-title) {
  border-color: #fcd34d;
  box-shadow: 0 10px 15px -3px rgba(245, 158, 11, 0.2);
}
.schedule-card.card-mon:hover .edit-btn-absolute { color: #d97706 !important; }
.schedule-card.card-mon .edit-btn-absolute:hover { background: #d97706 !important; color: white !important; }

/* Tuesday - Emerald */
.schedule-card.card-tue.has-content {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: #a7f3d0;
  color: #047857;
}
.schedule-card.card-tue.has-content:hover:not(.is-title) {
  border-color: #6ee7b7;
  box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.2);
}
.schedule-card.card-tue:hover .edit-btn-absolute { color: #059669 !important; }
.schedule-card.card-tue .edit-btn-absolute:hover { background: #059669 !important; color: white !important; }

/* Wednesday - Blue */
.schedule-card.card-wed.has-content {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #bfdbfe;
  color: #1d4ed8;
}
.schedule-card.card-wed.has-content:hover:not(.is-title) {
  border-color: #93c5fd;
  box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.2);
}
.schedule-card.card-wed:hover .edit-btn-absolute { color: #2563eb !important; }
.schedule-card.card-wed .edit-btn-absolute:hover { background: #2563eb !important; color: white !important; }

/* Thursday - Violet */
.schedule-card.card-thu.has-content {
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
  border-color: #ddd6fe;
  color: #6d28d9;
}
.schedule-card.card-thu.has-content:hover:not(.is-title) {
  border-color: #c4b5fd;
  box-shadow: 0 10px 15px -3px rgba(139, 92, 246, 0.2);
}
.schedule-card.card-thu:hover .edit-btn-absolute { color: #7c3aed !important; }
.schedule-card.card-thu .edit-btn-absolute:hover { background: #7c3aed !important; color: white !important; }

/* Friday - Pink */
.schedule-card.card-fri.has-content {
  background: linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%);
  border-color: #fbcfe8;
  color: #be185d;
}
.schedule-card.card-fri.has-content:hover:not(.is-title) {
  border-color: #f9a8d4;
  box-shadow: 0 10px 15px -3px rgba(236, 72, 153, 0.2);
}
.schedule-card.card-fri:hover .edit-btn-absolute { color: #db2777 !important; }
.schedule-card.card-fri .edit-btn-absolute:hover { background: #db2777 !important; color: white !important; }

/* Saturday - Teal */
.schedule-card.card-sat.has-content {
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-color: #99f6e4;
  color: #0f766e;
}
.schedule-card.card-sat.has-content:hover:not(.is-title) {
  border-color: #5eead4;
  box-shadow: 0 10px 15px -3px rgba(20, 184, 166, 0.2);
}
.schedule-card.card-sat:hover .edit-btn-absolute { color: #0d9488 !important; }
.schedule-card.card-sat .edit-btn-absolute:hover { background: #0d9488 !important; color: white !important; }

/* Sunday - Red */
.schedule-card.card-sun.has-content {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fecaca;
  color: #b91c1c;
}
.schedule-card.card-sun.has-content:hover:not(.is-title) {
  border-color: #fca5a5;
  box-shadow: 0 10px 15px -3px rgba(239, 68, 68, 0.2);
}
.schedule-card.card-sun:hover .edit-btn-absolute { color: #dc2626 !important; }
.schedule-card.card-sun .edit-btn-absolute:hover { background: #dc2626 !important; color: white !important; }


/* Custom Radio Pill */
.custom-radio-pill /deep/ .el-radio-button__inner {
  border-radius: 20px !important;
  border: 1px solid #dcdfe6 !important;
  margin-right: 12px;
  box-shadow: none !important;
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.3s ease;
}
.custom-radio-pill /deep/ .el-radio-button:last-child .el-radio-button__inner {
  margin-right: 0;
}
.custom-radio-pill /deep/ .el-radio-button.is-active .el-radio-button__inner {
  border-color: #2563eb !important;
  background-color: #2563eb !important;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3) !important;
}
.custom-radio-pill /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3) !important;
}

</style>